// extracted by mini-css-extract-plugin
export default {"form":"ForgotPassword_form__iOyPs","wrapper":"ForgotPassword_wrapper__jUaFO","link":"ForgotPassword_link__e93zT","button":"ForgotPassword_button__jtiaF"};